import { mapGetters } from 'vuex'

const dni = 'DNI / Pasaporte / Tarjeta de residencia'
const declaracionRentaFisica = 'Declaración de la renta de personas físicas'
const justificanteOrigenFondos = 'Justificante del origen de los fondos'
// const justificanteAhorros = 'Extracto bancario (Justificación de ahorros)'
// const justificanteHerencia = 'Testamento / Cuaderno particional (Justificación herencia)'
// const justificanteVenta = 'Escrituras venta de inmueble (Justificación venta de inmueble)'
// const justificanteDonacion = 'Justificante / Certificado de donación (Justificación donación)'
const contratoTrabajo = 'Contrato de trabajo (Justificación Trabajador por cuenta ajena)'
const nominas = 'Nóminas (Justificación Trabajador por cuenta ajena)'
const altaAutonomo = 'Justificante alta autónomo (Justificación Trabajador por cuenta propia)'
const dniRepresentante = 'DNI / Pasaporte / Tarjeta de Residencia del Representante'
const poderesRepresentante = 'Poderes del representante'
const escrituraConstitucion = 'Escritura de constitución'
const actaTitularidad = 'Acta de titularidad real'
const nifSociedad = 'NIF de la sociedad'
const impuestoDeSociedades = 'Impuesto de sociedades del ejercicio del último año'
const documentacionExtra = 'Documentación Extra'
const ultimasNominas = 'Tres últimas nóminas'
const ultimosAutonomos = 'Tres últimos justificantes de pago de autónomos'
const certificadoPension = 'Certificado de pensión / Documentación que justifique sus ingresos'
const ultimosTrimestres = 'Dos últimos trimestres IVA (Mod. 303 o 390)'
const movimientosBancarios = 'Movimientos bancarios del último semestre'
const morosidad = 'Solicitud consulta morosidad (2 hojas)'
const documentacionFlexible = 'Documentación aportada por el cliente de la operación'


export default {
  computed: {
    ...mapGetters({
      reserva: 'reservas/_id/getActual',
      moduloOrden: 'modulosOrdenes/getActual'
    }),
    carpetasConClaves () {
      return {
        dni,
        declaracionRentaFisica,
        justificanteOrigenFondos,
        contratoTrabajo,
        nominas,
        altaAutonomo,
        dniRepresentante,
        poderesRepresentante,
        escrituraConstitucion,
        actaTitularidad,
        nifSociedad,
        impuestoDeSociedades,
        documentacionExtra,
        ultimasNominas,
        ultimosAutonomos,
        certificadoPension,
        ultimosTrimestres,
        movimientosBancarios,
        morosidad,
        documentacionFlexible
      }
    },
    carpetasKycFisico () {
      return [
        dni,
        declaracionRentaFisica,
        justificanteOrigenFondos,
        contratoTrabajo,
        nominas,
        altaAutonomo,
        dniRepresentante,
        poderesRepresentante,
        documentacionExtra,
        ultimasNominas,
        ultimosAutonomos,
        certificadoPension,
        ultimosTrimestres,
        movimientosBancarios,
        morosidad
      ]
    },
    carpetasKycJuridico () {
      return [
        escrituraConstitucion,
        actaTitularidad,
        nifSociedad,
        dniRepresentante,
        poderesRepresentante,
        justificanteOrigenFondos,
        impuestoDeSociedades,
        documentacionExtra
      ]
    },
    documentacionExtra () {
      return this.compradores.length > 0 ? this.compradores.find(x => x.titular).documentacion.find(doc => this.esDocumentacionExtra(doc.carpeta)) : null
    },
    documentosExtra: {
      get () {
        return this.documentacionExtra ? this.documentacionExtra.documento : []
      },
      set (newVal) {
        const indexComprador = this.compradores.findIndex(x => x.titular)
        const indexDocumento = this.compradores[indexComprador].documentacion.findIndex(x => this.esDocumentacionExtra(x.carpeta))
        this.compradores[indexComprador].documentacion[indexDocumento].documento = newVal
      }
    },
    documentacionExtraValidada: {
      get () {
        return this.documentacionExtra ? this.documentacionExtra.validado : false
      },
      set (newVal) {
        const indexComprador = this.compradores.findIndex(x => x.titular)
        const indexDocumento = this.compradores[indexComprador].documentacion.findIndex(x => this.esDocumentacionExtra(x.carpeta))
        this.compradores[indexComprador].documentacion[indexDocumento].validado = newVal
      }
    },
    mostrarTextoValidadoDocExtra () {
      return this.documentacionExtra && this.documentosExtra && (this.documentosExtra.length > 0 || this.documentacionExtra.validado !== null) && this.documentacionExtra.validado === false
    },
    validacionDocumentacion () {
      return this.getTitular.validacionDocumentacion
    }
  },
  methods: {
    getDescripcionTraducida (descripcion) {
      if (descripcion === morosidad && this.moduloOrden.documentoMorosidadTitulo != '') {
        return this.moduloOrden.documentoMorosidadTitulo
      }
      let clave = Object.keys(this.carpetasConClaves).find(key => this.carpetasConClaves[key] === descripcion)
      return this.$t('mixins.documentacion.'+clave)
    },
    esDocumentacionExtra (carpeta) {
      return carpeta.descripcion === documentacionExtra
    },
    esDocumentacionMorosidad (carpeta) {
      return carpeta.descripcion === morosidad
    },
    tieneDocumentacionExtra (comprador) {
      return comprador.validacionDocumentacion == null ? false : comprador.validacionDocumentacion.habilitarSubidaExtra
    },
    estadoValidacionDocumento (doc, enValidacion, carpeta) {
      if (this.getCompradores.find(x => x.titular).validacionDocumentacion == null) {
        return -1
      } else if (doc.length === 0 && this.esDocumentacionExtra(carpeta)) {
        if (enValidacion) {
          return true
        } else {
          return null
        }
      } else if ((doc.length === 0 || doc.every(x => x.validado === false))) {
        return false
      } else if (doc.every(x => x.validado === true)) {
        return true
      } else if (doc.some(x => (x.validado === null || x.validado === undefined))) {
        return enValidacion ? false : null
      }
      return enValidacion ? false : null
    },
    claseSeccionValidacionDocumento (documento, mostrar) {
      if (mostrar) {
        return {
          'section-validado': documento.validado === true,
          'section-rechazado': documento.validado === false,
          'section-pendiente': documento.validado === null,
          'pt-3 pr-3 pb-2 pl-3 mb-3 section': !this.moduloOrden.aportarDocumentosFormaFlexible && !this.revisando,
          'pt-3 pr-3 pb-3 pl-3 mb-3 section': !this.moduloOrden.aportarDocumentosFormaFlexible && this.revisando
        }
      } else {
        return {}
      }
    },
    documentacionFiltrada (comprador) {
      let doc = comprador.documentacion
      if (this.moduloOrden.aportarDocumentosFormaFlexible) {
        doc = comprador.documentacion.filter(x => [documentacionFlexible].includes(x.carpeta.descripcion))
      } else {
        if (!comprador.juridico) {
          doc = comprador.documentacion.filter(x => this.carpetasKycFisico.includes(x.carpeta.descripcion))
          doc = this.filtrarDocumentacionFisico(comprador, doc)
          doc = doc.sort((a, b) => this.carpetasKycFisico.indexOf(a.carpeta.descripcion) - this.carpetasKycFisico.indexOf(b.carpeta.descripcion))
        } else {
          doc = comprador.documentacion.filter(x => this.carpetasKycJuridico.includes(x.carpeta.descripcion))
          doc = this.filtrarDocumentacionJuridico(comprador, doc)
          doc = doc.sort((a, b) => this.carpetasKycJuridico.indexOf(a.carpeta.descripcion) - this.carpetasKycJuridico.indexOf(b.carpeta.descripcion))
        }
      }
      return doc
    },
    filtrarDocumentacionFisico (comprador, documentacion) {
      let doc = documentacion
      if (this.moduloOrden.generarContratoKyc) {
        doc = this.filtrarDocGenerarContrato(comprador, doc)
      } else {
        doc = this.filtrarDocSinGenerarContrato(comprador, doc)
      }
      if (!this.moduloOrden.documentoMorosidadVisible) {
        doc = this.filtrarDocumentacionMorosidad(doc)
      }
      doc = this.filtrarDocumentacionExtra(comprador, doc)
      return doc
    },
    filtrarDocSinGenerarContrato (comprador, documentacion) {
      let doc = documentacion
      const carpetasSinContrato = [
        dni,
        declaracionRentaFisica,
        documentacionExtra,
        ultimasNominas,
        ultimosAutonomos,
        certificadoPension,
        ultimosTrimestres,
        morosidad
      ]
      doc = doc.filter(x => carpetasSinContrato.includes(x.carpeta.descripcion))
      // filtrar según actividad profesional
      if (comprador.kyc.actividadProfesional === 'cuentaAjena') {
        doc = doc.filter(x => (
          x.carpeta.descripcion !== ultimosAutonomos &&
          x.carpeta.descripcion !== certificadoPension &&
          x.carpeta.descripcion !== ultimosTrimestres
        ))
      } else if (comprador.kyc.actividadProfesional === 'cuentaPropia') {
        doc = doc.filter(x => (
          x.carpeta.descripcion !== ultimasNominas &&
          x.carpeta.descripcion !== certificadoPension &&
          x.carpeta.descripcion !== contratoTrabajo
        ))
      } else {
        doc = doc.filter(x => (
          x.carpeta.descripcion !== ultimasNominas &&
          x.carpeta.descripcion !== ultimosAutonomos &&
          x.carpeta.descripcion !== ultimosTrimestres &&
          x.carpeta.descripcion !== contratoTrabajo
        ))
      }
      return doc
    },
    filtrarDocGenerarContrato (comprador, documentacion) {
      let doc = documentacion
      doc = doc.filter(x => (
        x.carpeta.descripcion !== ultimasNominas &&
        x.carpeta.descripcion !== ultimosAutonomos &&
        x.carpeta.descripcion !== certificadoPension &&
        x.carpeta.descripcion !== ultimosTrimestres &&
        x.carpeta.descripcion !== movimientosBancarios &&
        x.carpeta.descripcion !== morosidad
      ))
      // filtrar si hay representante dni y poderes
      if (!comprador.kyc.representante) {
        doc = doc.filter(x => (x.carpeta.descripcion !== dniRepresentante && x.carpeta.descripcion !== poderesRepresentante))
      }
      // filtrar según actividad profesional
      if (comprador.kyc.actividadProfesional === 'cuentaAjena') {
        doc = doc.filter(x => x.carpeta.descripcion !== altaAutonomo)
      } else if (comprador.kyc.actividadProfesional === 'cuentaPropia') {
        doc = doc.filter(x => (x.carpeta.descripcion !== contratoTrabajo && x.carpeta.descripcion !== nominas))
      } else {
        doc = doc.filter(x => (x.carpeta.descripcion !== altaAutonomo && x.carpeta.descripcion !== contratoTrabajo && x.carpeta.descripcion !== nominas))
      }
      return doc
    },
    filtrarDocumentacionJuridico (comprador, documentacion) {
      let doc = documentacion
      if (!this.moduloOrden.documentoMorosidadVisible) {
        doc = this.filtrarDocumentacionMorosidad(doc)
      }
      doc = this.filtrarDocumentacionExtra(comprador, doc)
      return doc
    },
    filtrarDocumentacionExtra (comprador, documentacion) {
      if (comprador.titular /* && this.tieneDocumentacionExtra(comprador) */) {
        return documentacion
      }
      return documentacion.filter(doc => (!this.esDocumentacionExtra(doc.carpeta)))
    },
    filtrarDocumentacionMorosidad (documentacion) {
      return documentacion.filter(doc => !this.esDocumentacionMorosidad(doc.carpeta))
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/documentacion.js